import { TranslocoGlobalConfig } from '@jsverse/transloco-utils';

export const availableLangs = ['en', 'fr', 'es', 'de', 'it', 'nl'] as const;
export type AvailableLangs = (typeof availableLangs)[number];

const config: TranslocoGlobalConfig = {
  rootTranslationsPath: 'src/assets/i18n/',
  langs: [...availableLangs],
  keysManager: {},
  defaultLang: 'en',
};

export default config;
